import { Error } from 'Components'
import PropTypes from 'prop-types'
import { dispatchErrorReport } from 'Integrations/sentry'

class ErrorBoundary extends React.Component

  @propTypes = {
    children: PropTypes.node.isRequired
    Wrapper:  PropTypes.func
    ErrorView: PropTypes.func
  }

  @defaultProps = {
    Wrapper: ({ children }) ->
      <div> { children } </div>
    ErrorView: Error
  }

  constructor: (props) ->
    super(props)
    @state = {
      hasError: false
      info: ''
      error: ''
    }

  componentDidCatch: (error, info) ->
    @setState({ hasError: true, info, error })
    if process.env.NODE_ENV is 'production'
      dispatchErrorReport(error, info)

  render: ->
    { hasError, error, info } = @state
    { children, Wrapper, ErrorView } = @props

    unless hasError
      children
    else
      <Wrapper>
        <ErrorView error={error} info={info}/>
      </Wrapper>

export default ErrorBoundary
